import { connect } from 'react-redux';

import { ISubscriptionDispatchProps, ISubscriptionOwnProps, ISubscriptionStoreProps, Subscription } from '.';
import { IAppState, TThunkDispatch } from '../../../../../store';
import {
  deleteSubscriptionItem,
  ISubscriptionIsActiveParams,
  ISubscriptionsDeletedParams,
  updateIsActive,
} from '../../../../../store/subscriptions';

function mapStateToProps({ deviceType, token }: IAppState) {
  return {
    deviceType,
    token,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): ISubscriptionDispatchProps {
  return {
    deleteSubscriptionItem: (params: ISubscriptionsDeletedParams) => dispatch(deleteSubscriptionItem(params)),
    onChange: (params: ISubscriptionIsActiveParams) => dispatch(updateIsActive(params)),
  };
}

export const SubscriptionContainer = connect<
  ISubscriptionStoreProps,
  ISubscriptionDispatchProps,
  ISubscriptionOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(Subscription);
